import { useParams, useLocation } from 'react-router-dom'
import AppObjectContainer from '.'

export default function AppObjectRoute(props) {
  console.log('AppObjectRoute rendered', props)

  const params = useParams()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const actionId = searchParams.get('actionId')
  const source = searchParams.get('source')

  return (
    <AppObjectContainer objId={params.id} objActionId={actionId} initialSource={source} />
  )
}
